module.exports = __webpack_public_path__ + "img/delete.d3c32570.svg";